import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';
import { Clamp, Relay, Probe } from '.';

class ProductModuleDetail extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        lineType: PropTypes.string
    };

    static defaultProps = {
        lineType: null
    };

    render() {
        const { lineType } = this.props;
        const detailContentByType = {
            clamp: () => <Clamp {...this.props} />,
            probe: () => <Probe {...this.props} />,
            relay: () => <Relay {...this.props} />,
            default: () => null
        };
        return (detailContentByType[lineType] || detailContentByType['default'])();
    }
}

export default withTheme(ProductModuleDetail);



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/SDM17DEC/ProductModule/ProductModuleDetail.js